import React from 'react';
import UpgradeLink from '../UpgradeLink';
import {useState, useEffect} from 'react';

export const HiddenMessageDialog = ({message, isCreditSite, conversation}) => {
  let username = conversation.otherUserProfile?.username || 'User';
  const [countdown, setCountdown] = useState({
    hours: '00',
    minutes: '00',
    seconds: '00',
  });
  const countdownDefault = (countdown.hours === '00' && countdown.minutes === '00' && countdown.seconds === '00');
  const intervalTimer = function() {
    const c = window.startCountdownFromCCP(message).countdown;
    if (c) {
      setCountdown({
        hours: c.hours,
        minutes: c.minutes,
        seconds: c.seconds,
      });
    }
  }
  useEffect(() => {
    clearInterval(intervalTimer);
    if (typeof window !== 'undefined' && typeof window.startCountdownFromCCP === 'function') {
      setInterval(intervalTimer, 1000)
    }
  }, [message]);

  return (!countdownDefault &&
    <div className="unblock-message-dialog ccp-hidden-message-dialog">
      <p className="heading bold">{username} sent a special message!</p>
      <div className="countdown">
        <svg className="clock" width="40" height="40" viewBox="0 0 34 34" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M16.9119 28.1295C23.1817 28.1295 28.2643 23.0468 28.2643 16.7771C28.2643 10.5073 23.1817 5.42467 16.9119 5.42467C10.6422 5.42467 5.55953 10.5073 5.55953 16.7771C5.55953 23.0468 10.6422 28.1295 16.9119 28.1295Z"
            fill="currentColor"
          />
          <path
            d="M5.50723 33.9999C5.28981 33.9999 5.072 33.9273 4.89126 33.779C4.47765 33.4384 4.41779 32.827 4.75803 32.4131L7.77532 28.7454C8.11593 28.3322 8.72766 28.2723 9.14088 28.6126C9.55487 28.9532 9.61473 29.5645 9.27411 29.9785L6.25682 33.6462C6.06566 33.879 5.78722 33.9999 5.50723 33.9999Z"
            fill="currentColor"
          />
          <path
            d="M28.4954 33.9999C28.2154 33.9999 27.9374 33.879 27.7458 33.6461L24.7274 29.9785C24.3871 29.5649 24.4462 28.9532 24.8602 28.6126C25.2742 28.2723 25.8851 28.3318 26.2262 28.7454L29.2442 32.413C29.5848 32.8266 29.5254 33.4384 29.1118 33.779C28.9306 33.9273 28.7124 33.9999 28.4954 33.9999Z"
            fill="currentColor"
          />
          <path
            d="M17.0016 32.086C8.55567 32.086 1.68461 25.2149 1.68461 16.769C1.68461 8.32457 8.55567 1.45467 17.0016 1.45467C25.4464 1.45467 32.3171 8.32457 32.3171 16.769C32.3171 25.2149 25.4464 32.086 17.0016 32.086ZM17.0016 3.39526C9.62541 3.39526 3.6252 9.3947 3.6252 16.769C3.6252 24.1448 9.62541 30.1454 17.0016 30.1454C24.3767 30.1454 30.3765 24.1448 30.3765 16.769C30.3765 9.3947 24.3767 3.39526 17.0016 3.39526Z"
            fill="currentColor"
          />
          <path
            d="M21.261 17.7391H17.0465C16.5105 17.7391 16.076 17.3047 16.076 16.7686V5.97003C16.076 5.434 16.5105 4.99953 17.0465 4.99953C17.5825 4.99953 18.017 5.434 18.017 5.97003V15.7985H21.261C21.7974 15.7985 22.2318 16.233 22.2318 16.769C22.2318 17.305 21.7974 17.7391 21.261 17.7391Z"
            fill="#fff"
          />
          <path
            d="M17.0477 28.523C16.5113 28.523 16.0769 28.0886 16.0769 27.5525V25.1578C16.0769 24.6217 16.5113 24.1873 17.0477 24.1873C17.5834 24.1873 18.0178 24.6217 18.0178 25.1578V27.5525C18.0178 28.0886 17.5834 28.523 17.0477 28.523Z"
            fill="#fff"
          />
          <path
            d="M8.54948 17.7391H6.18949C5.65346 17.7391 5.219 17.3046 5.219 16.7686C5.219 16.2326 5.65346 15.7981 6.18949 15.7981H8.54948C9.08551 15.7981 9.51997 16.2326 9.51997 16.7686C9.51997 17.3046 9.08551 17.7391 8.54948 17.7391Z"
            fill="#fff"
          />
          <path
            d="M27.8137 17.7391H25.4529C24.9173 17.7391 24.4828 17.3046 24.4828 16.7686C24.4828 16.2326 24.9173 15.7981 25.4529 15.7981H27.8137C28.3501 15.7981 28.7846 16.2326 28.7846 16.7686C28.7846 17.3046 28.3501 17.7391 27.8137 17.7391Z"
            fill="#fff"
          />
          <path
            d="M1.15329 7.19815C0.617262 7.19815 0.1828 6.76369 0.1828 6.22766V4.16464C0.1828 1.86875 2.05195 0.000371307 4.349 0.000371307H6.41086C6.94689 0.000371307 7.38135 0.434833 7.38135 0.970863C7.38135 1.50689 6.94689 1.94135 6.41086 1.94135H4.349C3.12169 1.94135 2.1234 2.93888 2.1234 4.16503V6.22843C2.12378 6.76369 1.68932 7.19815 1.15329 7.19815Z"
            fill="currentColor"
          />
          <path
            d="M32.8472 7.19804C32.3112 7.19804 31.8767 6.76358 31.8767 6.22755V4.16453C31.8767 2.93839 30.8788 1.94086 29.6519 1.94086H27.59C27.0536 1.94086 26.6191 1.5064 26.6191 0.97037C26.6191 0.43434 27.0536 -0.00012207 27.59 -0.00012207H29.6519C31.9485 -0.00012207 33.8173 1.86826 33.8173 4.16415V6.22755C33.8177 6.76358 33.3832 7.19804 32.8472 7.19804Z"
            fill="currentColor"
          />
        </svg>
        <div className="timer">
									<span className="time-left">
										<span className="h">{countdown.hours}<span className="time-text">Hours</span></span
                    ><span className="sep">:</span> <span className="m">{countdown.minutes}<span
                    className="time-text">Minutes</span></span
                  ><span className="sep">:</span>
										<span className="s">{countdown.seconds}<span className="time-text">Seconds</span></span>
									</span>
        </div>
      </div>
      <p className="text">Reveal it now or lose it forever! Unlock it by <span className="bold">upgrading now</span>,
        time
        is ticking!</p>
      {isCreditSite &&
        <UpgradeLink className="btn dialog_button">Unlock Credits</UpgradeLink>
      }
      {!isCreditSite &&
        <UpgradeLink className="btn dialog_button">Upgrade Now</UpgradeLink>
      }
    </div>
  )
}
